// FIXED EXAMPLE
const awsmobile = {
    aws_project_region: 'ap-southeast-2',
    aws_cloud_logic_custom: [
        {
            name: 'cbx_CRUD_API',
            endpoint: 'https://zpke3ngd87.execute-api.ap-southeast-2.amazonaws.com/Live',
            region: 'ap-southeast-2'
        }
    ]
};

export default awsmobile;
